/**
 * Which blog posts belong in the sitemap / index.
 * Keep in sync with scripts/sitemap-blog-exclusions.cjs
 */

import { BLOG_REDIRECTS } from "../data/blogRedirects.js";

const GENERATOR_ACCIDENT_RE =
  /hey-claudei|title-for-the-blog-is|seo-blog-generator/;

const MILL_RE =
  /replit|wordpress|nextjs|next-js|reactjs|react-js|ad-variation|ad-variations|email-marketing|email-list|email-deliverability|email-subscriber|email-segmentation|subject-lines|re-engagement-emails|script-writing|ad-copy|ad-copywriting|content-marketing|business-blogging|blogging-builds|seo-blogs|payment-provider|payment-providers|payment-processing/;

const PRODUCT_MILL_RE =
  /ilmora|(?:^|-)lms(?:-|$)|white-label-lms|custom-lms|generic-lms|own-your-lms/;

const MODEL_MILL_RE = /claude|chatgpt/;

const KEEP_SLUGS = new Set([
  "the-hidden-cost-of-free-lms-platforms-for-schools-in-kuwait-and-saudi-arabia",
  "what-does-it-mean-to-own-your-lms-a-guide-for-schools-in-saudi-arabia",
  "the-accreditation-advantage-how-ilmora-helps-universities-in-saudi-arabia-meet-quality-standards",
  "5-signs-your-school-in-mena-has-outgrown-its-current-lms-platform",
  "why-k-12-schools-in-kuwait-are-choosing-ilmora-over-generic-learning-platforms",
  "ilmora-vs-generic-lms-what-universities-in-mena-are-comparing-before-they-decide",
  "how-claude-is-helping-saudi-enterprises-solve-their-arabic-content-problem",
  "claude-for-kuwait-smes-the-practical-guide-to-getting-started",
  "is-claude-the-best-ai-tool-for-arabic-language-business-content",
  "claude-vs-chatgpt-which-ai-actually-works-better-for-kuwait-businesses",
  "knet-vs-myfatoorah-vs-tap-payments-which-is-right-for-your-kuwait-business-in-2026",
  "how-to-use-ad-variation-data-to-build-smarter-campaigns-in-mena",
  "seasonal-ad-variation-strategy-for-kuwait-and-mena-ramadan-national-day-and-beyond",
  "when-to-stick-with-wordpress-and-when-to-upgrade-a-guide-for-kuwait-and-gulf-brands",
  "reactjs-vs-nextjs-which-framework-should-gulf-businesses-choose-in-2026",
  "arabic-blogging-why-kuwait-and-mena-businesses-are-missing-half-their-organic-traffic",
  "how-to-write-ad-copy-that-converts-arabic-speaking-audiences-in-kuwait-and-saudi-arabia",
  // Indexed in Google (GSC export, Oct 2026) but served noindex by the mill
  // rule. Content is cleaned at render time by src/utils/wispPostCleanup.js.
  "10-things-kuwait-developers-can-build-with-replit-in-2026",
  "10-wordpress-mistakes-kuwait-businesses-make-and-how-to-fix-them-with-ai",
  "email-deliverability-in-kuwait-how-ai-keeps-your-emails-out-of-spam",
  "how-ai-is-transforming-payment-processing-for-kuwait-and-gulf-brands-in-2026",
  "how-ai-is-transforming-wordpress-development-for-kuwait-and-saudi-arabia-brands",
  "how-replit-is-changing-the-way-gulf-teams-collaborate-on-code-in-2026",
  "is-replit-secure-enough-for-kuwait-and-gulf-business-applications-in-2026",
  "reactjs-state-management-in-2026-what-every-kuwait-developer-and-gulf-brand-needs-to-know",
  "what-is-wordpress-and-why-are-kuwait-businesses-still-building-with-it-in-2026",
  "why-every-kuwait-agency-should-be-using-claude-right-now",
  "wordpress-security-how-kuwait-and-gulf-brands-can-protect-their-websites-in-2026",
]);

function normalizeSlug(slug) {
  return String(slug || "")
    .trim()
    .toLowerCase();
}

function isMillSlug(slug) {
  const s = normalizeSlug(slug);
  if (!s) return true;
  if (GENERATOR_ACCIDENT_RE.test(s)) return true;
  if (KEEP_SLUGS.has(s)) return false;
  return MILL_RE.test(s) || PRODUCT_MILL_RE.test(s) || MODEL_MILL_RE.test(s);
}

/** Retired post: middleware 308s it (src/data/blogRedirects.js). */
export function getBlogRedirect(slug) {
  const s = normalizeSlug(slug);
  return Object.prototype.hasOwnProperty.call(BLOG_REDIRECTS, s)
    ? BLOG_REDIRECTS[s]
    : null;
}

export function isRedirectedBlogSlug(slug) {
  return getBlogRedirect(slug) !== null;
}

/* Redirected slugs count as excluded everywhere (listing, related links,
 * sitemap, JSON-LD) in case a CMS copy is still returned by the API. */
export function shouldNoindexBlogSlug(slug) {
  return isMillSlug(slug) || isRedirectedBlogSlug(slug);
}

export function shouldExcludeBlogSlugFromSitemap(slug) {
  return isMillSlug(slug) || isRedirectedBlogSlug(slug);
}

/** Rewrite apex / http agency URLs so crawlers do not keep discovering redirects. */
export function rewriteApexAgencyUrls(html = "") {
  return String(html)
    .replace(
      /https?:\/\/jamilglobal\.com(?=[:/?#]|$)/gi,
      "https://www.jamilglobal.com"
    )
    .replace(
      /http:\/\/www\.jamilglobal\.com/gi,
      "https://www.jamilglobal.com"
    );
}
